import { secureModeFirmwareVersions } from '../../../../helpers/constants';

/**
 * Settings tab for the US Wall Switch Gen3 SKUs (S3SW-1A1X5US, S3SW-0A1X5US).
 *
 * These two-input / single-output models expose only a subset of the generic
 * `settings_gen_2` surface in their local web / RPC API, plus the model-specific
 * Smart Switch Config (`wallswitch_ui`). This array is dedicated so the shared
 * `settings_gen_2` (used by ~70 relay configs) stays untouched.
 *
 * Differences from `settings_gen_2`:
 * - narrow input/output (Button locked, attached/detached, on/off/restore_last)
 * - Enable input 0 and Enable input 1 as two rows (device has input:0 + input:1)
 * - Invert input 0 and Invert input 1 as two rows
 * - Smart Switch Config (LED mode / indication / brightness / swap inputs)
 * - no operational counters
 */
export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{
			title: 'enhanced_security',
			component: 'enhanced_security_g2',
			min_ver: secureModeFirmwareVersions,
		},
		{ title: 'input_output', component: 'input_output_wall_switch_us_g3' },
		{
			title: 'enable_input_0',
			component: 'enable_input_by_id_g2',
			input_id: 0,
			min_ver: '1.0.7',
		},
		{
			title: 'enable_input_1',
			component: 'enable_input_by_id_g2',
			input_id: 1,
			min_ver: '1.0.7',
		},
		{ title: 'lock_inputs', component: 'lock_inputs_g2', min_ver: '1.6.0' },
		{ title: 'invert_input_0', component: 'invert_input_by_id_g2', input_id: 0 },
		{ title: 'invert_input_1', component: 'invert_input_by_id_g2', input_id: 1 },
		{ title: 'input_state', component: 'input_state' },
		{ title: 'smart_switch_config', component: 'wall_switch_ui_g3' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
